// import React from "react";

// export const TableView = ({ summaryData }) => {
//   return (
//     <div
//       className="  bg-white shadow-md  mt-2 w-full  rounded-tl-[15px]  rounded-tr-[15px]"
//       style={{ fontFamily: '"Poppins-Regular", Helvetica' }}
//     >
//      <div className="grid grid-cols-4 text-center text-white border-b bg-[#50869A] py-2 rounded-tl-[15px]  rounded-tr-[15px]">
//   <div
//     className="py-2 font-bold font-poppins text-left pl-4"
//     style={{ fontSize: "14px" }}
//   >
//     Type
//   </div>

//   <div
//     className="py-2 font-bold font-poppins text-left"
//     style={{ fontSize: "14px" }}
//   >
//     Description
//   </div>

//   <div
//     className="py-2 font-bold font-poppins"
//     style={{ fontSize: "14px" }}
//   >
//     Ordered by
//   </div>

//   <div
//     className="py-2 font-bold font-poppins"
//     style={{ fontSize: "14px" }}
//   >
//     Status
//   </div>
// </div>

//       <div className="grid gap-y-2 text-center">
//         {summaryData &&
//           summaryData.map((item) => (
//             <div className="grid grid-cols-4 border-b items-center py-2 px-2">
//               <div className="flex items-center justify-start">
//                 <button className="px-4 ml-4 uppercase font-poppins py-2 border-[1px] border-[#50869A] text-[10px] font-semibold text-[#1D2951] rounded-md shadow-md">
//                   {item.ordertype}
//                 </button>
//               </div>
//               <div
//                 className="text-[#212529] text-left leading-6 font-poppins"
//                 style={{ fontSize: "14px" }}
//               >
//                {item.ordername && item.ordername.trim() !== '' 
//   ? item.ordername 
//   : `${item.tov} - Level ${item.lov}`}

//               </div>
//               <div
//                 className="text-[#212529] font-poppins"
//                 style={{ fontSize: "14px" }}
//               >
//                 {item.provider}
//               </div>
//               <div>
//                 <div
//                   className={`w-3.5 h-3.5 rounded-full mx-auto ${
//                     item.status === "COMPLETED"
//                       ? "bg-[#649F70]"
//                       : item.status === "INFO"
//                       ? "bg-blue-500"
//                       : item.status === "CREATED"
//                       ? "bg-[#E17954]"
//                       : "bg-gray-400"
//                   }`}
//                 ></div>
//               </div>
//             </div>
//           ))}
//         {summaryData?.length === 0 && <p className="mt-4">No orders found.</p>}
//       </div>
//     </div>
//   );
// };


import React from "react";
import { DeleteGrayIcon } from "../tabsvgs";
export const TableView = ({ summaryData,handleDeleteOrder }) => {
  console.log(summaryData,'summaryData')
  // Get TYPE button color based on ordertype
  const getTypeColor = (ordertype) => {
    const type = ordertype?.toUpperCase();
    switch (type) {
      case "LABS":
        return {
          bg: "#EFF6FF",
          text: "#155DFC",
          border: "#DBEAFE",
        };
      case "VISIT":
        return {
          bg: "#EFF6FF",
          text: "#9810FA",
          border: "#F3E8FF",
        };
      case "SCHEDULE":
        return {
          bg: "#EFF6FF",
          text: "#4A5565",
          border: "#E5E7EB",
        };
      default:
        return {
          bg: "#F9FAFB",
          text: "#1D2951",
          border: "#50869A",
        };
    }
  };

  // Get STATUS styling based on status
  const getStatusStyle = (status) => {
    const statusUpper = status?.toUpperCase();
    switch (statusUpper) {
      case "COMPLETED":
        return {
          bg: "#E6F5E9",
          dot: "#649F70",
          text: "#649F70",
          label: "Completed",
        };
      case "PENDING":
        return {
          bg: "#FFF4E6",
          dot: "#E17954",
          text: "#E17954",
          label: "Pending",
        };
      case "CREATED":
        return {
          bg: "#FFF4E6",
          dot: "#E17954",
          text: "#E17954",
          label: "Pending",
        };
      case "INFO":
        return {
          bg: "#E6F0FF",
          dot: "#155DFC",
          text: "#155DFC",
          label: "Info",
        };
      default:
        return {
          bg: "#F3F4F6",
          dot: "#9CA3AF",
          text: "#9CA3AF",
          label: status || "Unknown",
        };
    }
  };

  return (
    <div
      className="  bg-white shadow-md  mt-2 w-full  rounded-tl-[15px]  rounded-tr-[15px]"
      style={{ fontFamily: '"Poppins-Regular", Helvetica' }}
    >
     <div className="grid grid-cols-5 text-center text-[#99A1AF] border-b bg-[#F9FAFB80] py-2 rounded-tl-[15px]  rounded-tr-[15px]">
  <div
    className="py-2 font-bold font-poppins text-left pl-4"
    style={{ fontSize: "12px" }}
  >
    Type
  </div>

  <div
    className="py-2 font-bold font-poppins text-left"
    style={{ fontSize: "12px" }}
  >
    Description
  </div>

  <div
    className="py-2 font-bold font-poppins"
    style={{ fontSize: "12px" }}
  >
    Ordered by
  </div>

  <div
    className="py-2 font-bold font-poppins"
    style={{ fontSize: "12px" }}
  >
    Status
  </div>
  
  <div
    className="py-2 font-bold font-poppins"
    style={{ fontSize: "12px" }}
  >
   Action
  </div>
</div>

      <div className="grid gap-y-2 text-center">
        {summaryData &&
          summaryData.map((item) => (
            <div className="grid grid-cols-5 border-b items-center py-2 px-2">
              <div className="flex items-center justify-start">
                {(() => {
                  const typeColors = getTypeColor(item.ordertype);
                  return (
                    <div
                      className="px-2 ml-4 uppercase font-poppins py-1 border-[1px] text-[10px] font-semibold rounded-md shadow-md cursor-default"
                      style={{
                        backgroundColor: typeColors.bg,
                        color: typeColors.text,
                        borderColor: typeColors.border,
                      }}
                    >
                      {item.ordertype}
                    </div>
                  );
                })()}
              </div>
              <div
                className="text-[#212529] text-left leading-6 font-poppins"
                style={{ fontSize: "14px" }}
              >
               {item.ordername && item.ordername.trim() !== '' 
  ? item.ordername 
  : `${item.tov} - Level ${item.lov}`}

              </div>
              <div
                className="text-[#212529] font-poppins"
                style={{ fontSize: "14px" }}
              >
                {item.provider}
              </div>
              <div className="flex items-center justify-center">
                {(() => {
                  const statusStyle = getStatusStyle(item.status);
                  return (
                    <div
                      className="flex items-center gap-2 px-3 py-1 rounded-full"
                      style={{
                        backgroundColor: statusStyle.bg,
                      }}
                    >
                      <div
                        className="w-2.5 h-2.5 rounded-full"
                        style={{
                          backgroundColor: statusStyle.dot,
                        }}
                      ></div>
                      <span
                        className="text-xs font-medium font-poppins"
                        style={{
                          color: statusStyle.text,
                        }}
                      >
                        {statusStyle.label}
                      </span>
                    </div>
                  );
                })()}
              </div>
              <div onClick={()=>{
                handleDeleteOrder(item.id)
              }} className="flex justify-center cursor-pointer">
                

                {DeleteGrayIcon}    
              
        
              </div>
            </div>
          ))}
        {summaryData?.length === 0 && <p className="mt-4">No orders found.</p>}
      </div>
    </div>
  );
};
